import { Typography, Link as MuiLink } from '@mui/material'
import Link from 'next/link'
import type { FallbackRender } from '@sentry/react'

import { IS_PRODUCTION } from '@/config/constants'
import { AppRoutes } from '@/config/routes'
import WarningIcon from '@/public/images/notifications/warning.svg'

import css from '@/components/common/ErrorBoundary/styles.module.css'
import CircularIcon from '../icons/CircularIcon'

const ErrorBoundary: FallbackRender = ({ error, componentStack }) => {
  return (
    <div className={css.container}>
      <div className={css.wrapper}>
        <Typography variant="h3" color="text.primary">
          Something went wrong,
          <br />
          please try again.
        </Typography>

        <CircularIcon icon={WarningIcon} badgeColor="warning" />

        {!IS_PRODUCTION && (
          <>
            {/* Error may be undefined despite what the type says */}
            <Typography color="error">{error?.toString()}</Typography>
            <Typography color="error">{componentStack}</Typography>
          </>
        )}
        <Typography mt={2}>
          <Link href={AppRoutes.welcome} passHref target="_blank" rel="noopener noreferrer" color="primary">
            <MuiLink>Go Home</MuiLink>
          </Link>
        </Typography>
      </div>
    </div>
  )
}

export default ErrorBoundary
